import { render, staticRenderFns } from "./archivioFSCGruppo.html?vue&type=template&id=14b2ebd1&scoped=true&external"
import script from "./ArchivioFSCGruppo.vue?vue&type=script&lang=js"
export * from "./ArchivioFSCGruppo.vue?vue&type=script&lang=js"
import style0 from "./ArchivioFSCGruppo.vue?vue&type=style&index=0&id=14b2ebd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b2ebd1",
  null
  
)

export default component.exports